module.exports = __webpack_public_path__ + "img/image39.ea50b657.webp";